const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3005/api',
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
};

export default config; 